import { COMPARATOR_TYPE } from '../../funnels';

export enum COVERAGE {
  ALL_RISK = 'all_risk',
  ANTIQUE = 'antique',
  ART = 'art',
  AUDIO_TV = 'audio_tv',
  COLLECTION = 'collection',
  COMPUTERS = 'computers',
  GLASS = 'glass',
  JEWELRY = 'jewelry',
  LIABILITY_125 = 'liability_125',
  LIABILITY_250 = 'liability_250',
  INSTRUMENTS = 'instruments',
  OUTDOOR_COVERAGE_25 = 'outdoor_coverage_25',
  OUTDOOR_COVERAGE_50 = 'outdoor_coverage_50',
  OUTDOOR_COVERAGE_75 = 'outdoor_coverage_75',
  OUTDOOR_COVERAGE_100 = 'outdoor_coverage_100',
}

export enum INTERNET_FILTERS {
  DOWNLOAD_SPEED = 'downloadSpeed',
  SIGNAL = 'signal',
}

export const ALL = 'all';

export enum FILTER {
  ADDITIONAL_COVERAGE = 'additionalCoverage',
  CONSTANT_TARIFF = 'isConstantTariff',
  CONTRACT_TYPE = 'contract_type',
  CONTRACT_DURATION = 'contractDuration',
  FILTER_OPTIONS = 'filterOptions',
  GREEN_POWER = 'greenPower',
  MAX_OWN_RISK = 'maxOwnRisk',
  ORDERABLE = 'isOrderable',
  POSTCODEROOSREGELING = 'postcoderoosregeling',
  PROVIDER_NAME = 'providerName',
  SHOW_PRICE_MODE = 'showPriceMode',
  SUSTAINABILITY_LABEL = 'sustainabilityLabel',
  SUSTAINABILITY_SCORE = 'sustainabilityScore',
}

export const AVAILABLE_FILTERS = {
  [COMPARATOR_TYPE.ENERGY]: {
    [FILTER.CONTRACT_DURATION]: 'Looptijd',
    [FILTER.CONTRACT_TYPE]: 'Type contract',
    [FILTER.GREEN_POWER]: 'Groene stroom',
    [FILTER.POSTCODEROOSREGELING]: 'Postcoderoosregeling',
    [FILTER.PROVIDER_NAME]: 'Leverancier',
  },
  [COMPARATOR_TYPE.HOME]: {
    [FILTER.ADDITIONAL_COVERAGE]: 'Aanvullende dekking',
    [FILTER.FILTER_OPTIONS]: 'Filteropties',
    [FILTER.MAX_OWN_RISK]: 'Max. eigen risico',
    [FILTER.SUSTAINABILITY_LABEL]: 'Duurzaamheidsscore',
    [FILTER.PROVIDER_NAME]: 'Verzekeraars',
  },
};

export const ADDED_FILTERS_SOURCE = {
  [FILTER.CONTRACT_TYPE]: 'products[0].filters.contract_type',
  [FILTER.GREEN_POWER]: 'products[1].filters.green',
  [FILTER.ORDERABLE]: 'availability.acceptance.accepted',
  [FILTER.POSTCODEROOSREGELING]: 'provider.attributes.postcoderoosregeling',
  [FILTER.SUSTAINABILITY_LABEL]: 'provider.attributes.sustainabilityScore',
  [FILTER.SUSTAINABILITY_SCORE]: 'provider.attributes.sustainabilityScore',
};

export enum SUSTAINABILITY {
  LOW = 'laag',
  MEDIUM = 'gemiddeld',
  HIGH = 'hoog',
}

export enum POWER {
  GREY = 'Grijs',
  GREEN = 'Groen',
  EXTRA_GREEN = 'Extra groen',
}

export enum OWN_RISK {
  MAX_150 = 'max_150',
  MAX_250 = 'max_250',
  MAX_500 = 'max_500',
  NO = 'no',
}

export enum FILTER_OPTION {
  DAILY_TERMINABLE = 'Dagelijks opzegbaar',
  GUARANTEE_AGAINST_UNDERINSURANCE = 'Garantie tegen onderverzekering',
}

export const FILTER_LABELS = {
  [FILTER.CONTRACT_DURATION]: getDurationLabel,
  [FILTER.POSTCODEROOSREGELING]: (): string => {
    return 'Toon leveranciers die meedoen';
  },
  [FILTER.ORDERABLE]: (): string => {
    return 'Via ons aan te vragen';
  },
};

export const FILTER_TOOLTIP = {
  [COMPARATOR_TYPE.ENERGY]: {
    [FILTER.CONTRACT_DURATION]: 'Voor hoelang wil je het contract afsluiten?',
    [FILTER.GREEN_POWER]:
      'Grijze stroom wordt opgewekt uit fossiele brandstoffen als aardgas, olie en steenkolen.<br/><br/>Groene stroom wordt opgewekt met natuurlijke energiebronnen als zon, wind of water.<br/><br/>Groene stroom uit Nederland is voor 100% afkomstig uit Nederlandse natuurlijke energiebronnen.',
    [FILTER.POSTCODEROOSREGELING]:
      "Met de postcoderoosregeling schaf je zonnepanelen aan die niet op je eigen dak liggen. In plaats daarvan komen ze binnen een 'postcoderoos'-project. Je wordt dan lid van een coöperatie en krijgt via je energieleverancier korting op de energiebelasting.<br/><br/>Sinds 1 april 2021 is de regeling vervangen door een subsidie. Als je de regeling nog niet gebruikt, kun je er dus ook geen aanspraak meer op maken. Gebruik je de regeling al? Voor jou verandert er dan niets en blijft de regeling nog maximaal tot 15 jaar na de ingangsdatum geldig.",
    [FILTER.SUSTAINABILITY_LABEL]:
      'De duurzaamheidsscore baseren we op de samenstelling van het stroometiket, investeringsbeleid en de productie/inkoop van de aanbieder. De onderdelen wegen niet even zwaar. Dus het totaaloordeel is niet het gemiddelde van de drie gegeven sterren.',
  },
};

export const FIELD_VALUES = {
  [FILTER.SUSTAINABILITY_LABEL]: (score: number) => {
    if (
      score >= SUSTAINABILITY_SCORES[0].valueStart &&
      score <= SUSTAINABILITY_SCORES[0].valueEnd
    ) {
      return SUSTAINABILITY.LOW;
    } else if (
      score >= SUSTAINABILITY_SCORES[1].valueStart &&
      score <= SUSTAINABILITY_SCORES[1].valueEnd
    ) {
      return SUSTAINABILITY.MEDIUM;
    } else {
      return SUSTAINABILITY.HIGH;
    }
  },
};

export const GLOBAL_FILTERS = {
  [FILTER.CONTRACT_TYPE]: [
    {
      label: 'Vast',
      value: '1',
      optionTooltip:
        'Kies je voor vast? Dan kies je voor zekerheid. Je energietarieven blijven gelijk tijdens de looptijd van je contract.' +
        'Heb je zonnepanelen? Per 1 januari 2027 vervalt de salderingsregeling. Wat de terugleverkosten en -vergoeding daarna zullen worden, is nog niet duidelijk. In de huidige berekening is er dan ook nog geen rekening gehouden met deze wijziging.',
    },
    {
      label: 'Variabel',
      value: '2',
      optionTooltip:
        'Kies je voor variabel? Dan kunnen je tarieven tussentijds stijgen of dalen. Of je dan meer of minder gaat betalen, hangt af van invloeden op de energiemarkt.',
    },
    {
      label: 'Dynamisch',
      value: '3',optionTooltip:
        'Kies je voor dynamisch? Dan kunnen je tarieven voor stroom per uur wijzigen en voor gas per dag.',
    },
  ],
  [FILTER.GREEN_POWER]: [
    {
      label: 'Geen voorkeur',
      value: ALL,
    },
    {
      label: 'Alleen groen',
      value: POWER.GREEN,
    },
    {
      label: 'Alleen groen uit Nederland',
      value: POWER.EXTRA_GREEN,
    },
  ],
  [FILTER.POSTCODEROOSREGELING]: [
    {
      label: 'Toon leveranciers die meedoen',
      value: 'true',
    },
  ],
  [FILTER.SUSTAINABILITY_LABEL]: [
    {
      label: `Laag (tot 6)`,
      value: SUSTAINABILITY.LOW,
    },
    {
      label: `Gemiddeld (6 tot 8)`,
      value: SUSTAINABILITY.MEDIUM,
    },
    {
      label: `Hoog (8 t/m 10)`,
      value: SUSTAINABILITY.HIGH,
    },
  ],
};

export const FILTER_FIELDS = {
  [COMPARATOR_TYPE.ENERGY]: {
    ...GLOBAL_FILTERS,
    [FILTER.ORDERABLE]: [
      {
        label: 'Via ons aan te vragen',
        value: 'true',
      },
    ],
  },
  [COMPARATOR_TYPE.HOME]: {
    ...GLOBAL_FILTERS,
    [FILTER.ADDITIONAL_COVERAGE]: [
      {
        label: 'Aansprakelijkheid',
        value: [
          {
            label: '€ 1.250.000,-',
            value: COVERAGE.LIABILITY_125,
          },
          {
            label: '€ 2.500.000,-',
            value: COVERAGE.LIABILITY_250,
          },
        ],
      },
      {
        label: 'Allrisk',
        value: COVERAGE.ALL_RISK,
      },
      {
        label: 'Buitenhuisdekking',
        value: [
          {
            label: 'Minimaal €2.500,-',
            value: COVERAGE.OUTDOOR_COVERAGE_25,
          },
          {
            label: 'Minimaal €5.000,-',
            value: COVERAGE.OUTDOOR_COVERAGE_50,
          },
          {
            label: 'Minimaal €7.500,-',
            value: COVERAGE.OUTDOOR_COVERAGE_75,
          },
          {
            label: 'Minimaal €10.000,-',
            value: COVERAGE.OUTDOOR_COVERAGE_100,
          },
        ],
      },
      {
        label: 'Glas',
        value: COVERAGE.GLASS,
      },
      {
        label: 'Audio / tv',
        value: COVERAGE.AUDIO_TV,
      },
      {
        label: 'Computers',
        value: COVERAGE.COMPUTERS,
      },
      {
        label: 'Sieraden',
        value: COVERAGE.JEWELRY,
      },
      {
        label: 'Kunst',
        value: COVERAGE.ART,
      },
      {
        label: 'Instrumenten',
        value: COVERAGE.INSTRUMENTS,
      },
      {
        label: 'Antiek',
        value: COVERAGE.ANTIQUE,
      },
      {
        label: 'Verzameling',
        value: COVERAGE.COLLECTION,
      },
    ],
    [FILTER.FILTER_OPTIONS]: [
      {
        label: 'Dagelijks opzegbaar',
        value: FILTER_OPTION.DAILY_TERMINABLE,
      },
      {
        label: 'Garantie tegen onderverzekering',
        value: FILTER_OPTION.GUARANTEE_AGAINST_UNDERINSURANCE,
      },
    ],
    [FILTER.MAX_OWN_RISK]: [
      {
        label: 'Geen voorkeur',
        value: ALL,
      },
      {
        label: 'Geen eigen risico',
        value: OWN_RISK.NO,
      },
      {
        label: 'Maximaal €150,-',
        value: OWN_RISK.MAX_150,
      },
      {
        label: 'Maximaal €250,-',
        value: OWN_RISK.MAX_250,
      },
      {
        label: 'Maximaal €500,-',
        value: OWN_RISK.MAX_500,
      },
    ],
  },
};

export const FILTERS_TO_EXCLUDE_COUNT = ['showPriceMode'];

export const FILTERS_TYPE = {
  [FILTER.GREEN_POWER]: 'radio-group',
  [FILTER.SHOW_PRICE_MODE]: 'radio-group',
  [FILTER.ORDERABLE]: 'checkbox',
};

export const SUSTAINABILITY_SCORES = [
  {
    valueStart: 0,
    valueEnd: 5.9,
  },
  {
    valueStart: 6,
    valueEnd: 7.9,
  },
  {
    valueStart: 8,
    valueEnd: 10,
  },
];

function getDurationLabel(months: number) {
  if (months === 0) {
    return 'Variabel';
  } else if (months < 12) {
    return `${months} ${months === 1 ? 'maand' : 'maanden'}`;
  } else {
    return `${Math.round(months / 12)} jaar`;
  }
}
